module.exports = __webpack_public_path__ + "img/thumb_unfilled.66ceb3fb.png";